import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'list-chevrons-down-up',
  size: 24,
  node: [
    ['path', { d: 'M3 5h8', key: '18g2rq' }],
    ['path', { d: 'M3 12h8', key: '1xfjp6' }],
    ['path', { d: 'M3 19h8', key: 'fpbke4' }],
    ['path', { d: 'm15 5 3 3 3-3', key: '1t4thf' }],
    ['path', { d: 'm15 19 3-3 3 3', key: 'y4ckd2' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name ListChevronsDownUp
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMyA1aDgiIC8+CiAgPHBhdGggZD0iTTMgMTJoOCIgLz4KICA8cGF0aCBkPSJNMyAxOWg4IiAvPgogIDxwYXRoIGQ9Im0xNSA1IDMgMyAzLTMiIC8+CiAgPHBhdGggZD0ibTE1IDE5IDMtMyAzIDMiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/list-chevrons-down-up
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ListChevronsDownUp = createLucideIcon(__iconData);

export default ListChevronsDownUp;
